import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";
import { SwarovskiRadio } from "../../../components/_shared-components/ui-elements/SwarovskiRadio";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_SPACER_SIZES } from "../../../styles/styles-css-variables";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";

export const PCPDifferencesModeSwitch: ReactTFC<{
  mode: "all" | "differences-only";
  toggleMode: () => void;
  showOnlyDifferencesLabel: React.ReactNode;
  selectedProductsCount: number;
}> = props => {
  return (
    <div
      className={`selected-${props.selectedProductsCount}`}
      css={css`
        width: 100%;

        ${CSS_MQ.atMostSm} {
          &.selected-3 {
            width: 125vw;
            padding-right: 20px;
          }
        }

        margin-bottom: ${CSS_SPACER_SIZES.md};
      `}
    >
      <hr />

      <div
        css={css`
          padding: 40px 0;

          display: flex;
          justify-content: center;
        `}
      >
        <SwarovskiRadio
          customColorInput={undefined}
          labelProps={{
            className: "label",
          }}
          inputProps={{
            value: props.mode,
            disabled: false,
            checked: props.mode === "differences-only",
            onChange: () => props.toggleMode(),
            name: "mode",
          }}
          type={"checkbox"}
          attachStyles={css`
            display: flex;

            > .label {
              order: -1;

              ${FONTS.SwarovskiFutura500};
              ${fontColor.black};
              ${fontSize.x2};

              text-transform: uppercase;

              margin-right: 20px;
              margin-top: 5px;
            }
          `}
        >
          {props.showOnlyDifferencesLabel}
        </SwarovskiRadio>
      </div>

      <hr />
    </div>
  );
};
